import { getMeApi } from "../../Api/Auth/getMeApi"
import * as types from "../actionTypes"

export const getMeStart = () => ({ type: types.GET_ME_START })
export const getMeSuccess = (data) => ({ type: types.GET_ME_SUCCESS, payload: data })
export const getMeError = (error) => ({ type: types.GET_ME_ERROR, payload: error })

export const getMeActionInitiate = (onSuccess, onError) => {
  return async function (dispatch) {
    dispatch(getMeStart())
    try {
      const res = await getMeApi()
      dispatch(getMeSuccess(res.data))
      onSuccess && onSuccess(res.data.user)
    } catch (error) {
      const msg = error?.response?.data?.error || error?.message || "Session expired"
      dispatch(getMeError(msg))
      onError && onError()
    }
  }
}
